import HttpClient from './httpClient';

export const getAlternativeInsurers = () =>
  new HttpClient.Builder().get('/config/alternative-insurers/').unsecured().execute();
